var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _g, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrayStep1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0222 0H99.9778C111.037 0 120 8.35368 120 18.6626V101.337C120 111.646 111.037 120 99.9778 120H20.0222C8.96338 120 0 111.646 0 101.337V18.6626C0 8.35368 8.96338 0 20.0222 0Z",
    fill: "#EFEFEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.02246 96.7332V53.0412C9.02246 43.6837 16.6343 36.0902 26.0301 36.0902H93.0674C102.456 36.0902 110.075 43.6767 110.075 53.0412V96.7332C110.075 106.091 102.463 113.684 93.0674 113.684H26.0301C16.6343 113.677 9.02246 106.091 9.02246 96.7332Z",
    fill: "#ABABAB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3078 102.168C75.0142 102.168 87.7468 89.4351 87.7468 73.7287C87.7468 58.0223 75.0142 45.2898 59.3078 45.2898C43.6014 45.2898 30.8689 58.0223 30.8689 73.7287C30.8689 89.4351 43.6014 102.168 59.3078 102.168Z",
    fill: "#FFF7E6",
    stroke: "#C7C7C7",
    strokeWidth: 13.4096,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.2282 27.0678C56.8917 27.0887 55.0148 28.8303 55.0378 30.9551C55.0838 35.0165 55.1221 39.0849 55.1297 43.1464C55.1451 48.1413 55.1221 53.1362 55.1221 58.1312C55.1221 61.071 55.1297 64.0109 55.1297 66.9507C55.1297 67.9817 55.1297 69.0128 55.1221 70.0508C55.1221 70.3434 55.1144 70.6359 55.1068 70.9285C55.1068 71.0818 55.1068 71.2351 55.0914 71.3883C55.0914 71.4092 55.0991 71.3535 55.0991 71.3326C54.8616 73.5688 56.6542 75.5543 59.1133 75.7702C61.5724 75.9862 63.7633 74.356 64.0008 72.1198C64.0697 71.458 64.0544 70.7753 64.0544 70.1135C64.0621 69.0546 64.0621 68.0026 64.0544 66.9437C64.0391 63.8855 64.0084 60.8342 63.9625 57.7759C63.8859 52.8785 63.7633 47.9811 63.679 43.0837C63.6024 39.0153 63.5565 34.9538 63.5028 30.8854C63.4722 28.7537 61.5647 27.0469 59.2282 27.0678Z",
    fill: "#999999"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9473 48.2707C18.9473 46.0306 20.7673 44.2106 23.0074 44.2106C25.2475 44.2106 27.0676 46.0306 27.0676 48.2707C27.0676 50.5108 25.2475 52.3309 23.0074 52.3309C20.7673 52.3309 18.9473 50.5108 18.9473 48.2707Z",
    fill: "#999999"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.0591 33.6224C58.1002 33.0462 60.5609 16.5185 70.8482 10.8476C79.7041 5.97083 95.5757 4.95893 99.1505 8.12112C100.977 9.73735 95.8578 24.178 85.7538 30.3689C75.6428 36.5597 62.0346 35.4073 59.0591 33.6224Z",
    fill: "#999999"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.7822 35.0405C75.6126 34.6901 81.1582 33.4009 85.9225 30.4554C95.9652 24.2423 101.053 9.74968 99.2379 8.12764C97.6894 6.74448 93.8191 6.15706 89.2163 6.3397C89.3897 7.83182 89.3319 11.152 87.0793 16.8585C83.3359 26.3475 75.2788 32.3146 70.7822 35.0405Z",
    fill: "#C7C7C7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2407 55.9399C16.2407 54.9416 16.8454 54.1354 17.5941 54.1354C18.3428 54.1354 18.9475 54.9416 18.9475 55.9399C18.9475 56.9381 18.3428 57.7444 17.5941 57.7444C16.8454 57.7444 16.2407 56.9381 16.2407 55.9399Z",
    fill: "#999999"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4587 59.1017C23.4587 58.3563 24.0629 57.7444 24.8082 57.7444C25.5535 57.7444 26.1655 58.3485 26.1655 59.1017C26.1655 59.847 25.5614 60.4511 24.8082 60.4511C24.0629 60.4589 23.4587 59.8548 23.4587 59.1017Z",
    fill: "#999999"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.5413 93.8346C96.5413 92.3362 97.7566 91.1278 99.248 91.1278C100.746 91.1278 101.955 92.3431 101.955 93.8346C101.955 95.333 100.74 96.5413 99.248 96.5413C97.7496 96.5413 96.5413 95.333 96.5413 93.8346Z",
    fill: "#999999"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.5188 99.6992C87.5188 98.9495 88.1225 98.3458 88.8722 98.3458C89.6218 98.3458 90.2256 98.9495 90.2256 99.6992C90.2256 100.449 89.6218 101.053 88.8722 101.053C88.1291 101.053 87.5188 100.442 87.5188 99.6992Z",
    fill: "#999999"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.7368 104.211C94.7368 101.973 96.5519 100.15 98.797 100.15C101.042 100.15 102.857 101.965 102.857 104.211C102.857 106.456 101.042 108.271 98.797 108.271C96.5519 108.263 94.7368 106.448 94.7368 104.211Z",
    fill: "#999999"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.8431 32.9347C59.8032 32.332 56.2991 17.2996 46.1303 10.8241C35.9615 4.34855 21.7281 6.13562 18.6094 8.23806C16.528 9.63968 23.0386 25.6602 32.7939 31.8484C42.5492 38.0366 55.8506 34.8058 58.8431 32.9347Z",
    fill: "#999999"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_395_722",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 6,
    width: 41,
    height: 30
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.8469 32.7749C59.8124 32.1689 56.2889 17.0532 46.0638 10.5418C35.8386 4.03045 21.5263 5.82742 18.3904 7.94151C16.2975 9.3509 22.8441 25.4602 32.6534 31.6827C42.4628 37.9051 55.8379 34.6565 58.8469 32.7749Z",
    fill: "#C7C7C7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_395_722)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.1271 8.61108C47.1271 8.61108 51.4046 18.0822 48.3181 24.4879C45.2244 30.8935 33.9211 34.0647 33.9211 34.0647C33.9211 34.0647 37.9168 36.1858 44.0124 36.7002C45.5768 36.8341 46.8171 36.8693 48.3533 36.8693C51.3905 36.8693 53.9274 36.5452 53.9274 36.5452C53.9274 36.5452 55.1818 35.5938 55.7596 34.7412C58.9801 29.9845 57.2043 20.0342 57.2043 20.0342C57.2043 20.0342 55.4918 16.5248 52.1375 12.7829C49.6147 9.98524 47.1271 8.61108 47.1271 8.61108Z",
    fill: "#C7C7C7"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.4341 15.4459C29.4341 13.4906 31.0179 11.9138 32.9662 11.9138C34.9214 11.9138 36.4983 13.4977 36.4983 15.4459C36.4983 17.4012 34.9144 18.978 32.9662 18.978C31.0179 18.978 29.4341 17.3942 29.4341 15.4459Z",
    fill: "#999999"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.7676 21.8163C34.7676 21.0804 35.3633 20.4847 36.0991 20.4847C36.835 20.4847 37.4307 21.0804 37.4307 21.8163C37.4307 22.5521 36.835 23.1478 36.0991 23.1478C35.3633 23.1478 34.7676 22.5521 34.7676 21.8163Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayStep1);
export default __webpack_public_path__ + "static/media/grayStep1.d70424006b23ed881bbc3977d06cec54.svg";
export { ForwardRef as ReactComponent };